import { connect } from 'react-redux';
import KlentyAuthenticationView from './klentyAuthenticationView.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/klenty.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'klenty');
  return {
    integration: integration,
    activating: state.legacyRootReducer.settings.integrations.klenty.activating,
    error: state.legacyRootReducer.settings.integrations.klenty.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (apikey, userName, isAccountLevel) => {
      return dispatch(authenticateAccount(apikey, userName, isAccountLevel));
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  }
}

const KlentyAuthenticationPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(KlentyAuthenticationView);

export default KlentyAuthenticationPage;